<template>
    <div>
        <b-navbar toggleable="md" type="dark" variant="secondary">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand to="/"><span style="font-weight: 700">Audit</span>Assistant</b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                <b-nav-item to="/catalogues">Catalogues</b-nav-item>
                <b-nav-item to="/audits">Audits</b-nav-item>
                <b-nav-item to="/kb/1">Knowledge base</b-nav-item>
            </b-navbar-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
            <!--
            <b-nav-form>
                <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search"/>
                <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
            </b-nav-form>
            -->

            <b-nav-item-dropdown right>
                <!-- Using button-content slot -->
                <template slot="button-content">
                <em>Max Mustermann</em>
                </template>
                <b-dropdown-item href="#">Profile</b-dropdown-item>
                <b-dropdown-item href="#" @click="signout">Signout</b-dropdown-item>
            </b-nav-item-dropdown>
            </b-navbar-nav>

  </b-collapse>
</b-navbar>
    </div>
</template>


<script>
export default {
  name: 'navbar',
  components: {
  },
  methods: {
      signout() {
          this.$emit("signout");
      }
  }
}
</script>

<style>
</style>